import type { StateStorage } from "zustand/middleware";
import { AUTH_STORAGE_KEY, readPersistedAuthTokens } from "./authStorage";

/**
 * Zustand persist storage: token fields always mirror {@link readPersistedAuthTokens},
 * never in-memory zustand state (only {@link persistAuthTokens} writes tokens).
 */
export const authPersistStorage: StateStorage = {
  getItem: (name) => {
    if (typeof window === "undefined") {
      return null;
    }
    return window.localStorage.getItem(name);
  },
  setItem: (name, value) => {
    if (typeof window === "undefined") {
      return;
    }
    if (name !== AUTH_STORAGE_KEY) {
      window.localStorage.setItem(name, value);
      return;
    }

    let merged = value;
    try {
      const parsed = JSON.parse(value) as {
        state?: { accessToken?: string | null; refreshToken?: string | null };
        version?: number;
      };
      const { accessToken, refreshToken } = readPersistedAuthTokens();
      if (!accessToken && !refreshToken) {
        window.localStorage.removeItem(name);
        return;
      }
      if (parsed.state) {
        parsed.state.accessToken = accessToken;
        parsed.state.refreshToken = refreshToken;
        merged = JSON.stringify(parsed);
      }
    } catch {
      /* keep original value */
    }
    window.localStorage.setItem(name, merged);
  },
  removeItem: (name) => {
    if (typeof window === "undefined") {
      return;
    }
    window.localStorage.removeItem(name);
  },
};
